/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AdminVoucherCategoryDto,
  AdminVoucherCategoryRequestDto,
  AdminVoucherDto,
  AdminVoucherRequestDto,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class AdminVoucherService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags AdminVoucherService
   * @name GetVoucherCategory
   * @summary Get Voucher Category by ID
   * @request GET:/v1/admin/voucher-categories/{categoryId}
   * @secure
   */
  getVoucherCategory = (categoryId: number, params: RequestParams = {}) =>
    this.http.request<AdminVoucherCategoryDto, any>({
      path: `/v1/admin/voucher-categories/${categoryId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminVoucherService
   * @name UpdateVoucherCategory
   * @summary Update Voucher Category
   * @request PUT:/v1/admin/voucher-categories/{categoryId}
   * @secure
   */
  updateVoucherCategory = (
    categoryId: number,
    data: AdminVoucherCategoryRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<AdminVoucherCategoryDto, any>({
      path: `/v1/admin/voucher-categories/${categoryId}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminVoucherService
   * @name DeleteVoucherCategory
   * @summary Delete Voucher Category
   * @request DELETE:/v1/admin/voucher-categories/{categoryId}
   * @secure
   */
  deleteVoucherCategory = (categoryId: number, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/admin/voucher-categories/${categoryId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminVoucherService
   * @name GetVoucher
   * @summary Get Voucher by ID
   * @request GET:/v1/admin/voucher-categories/{categoryId}/vouchers/{voucherId}
   * @secure
   */
  getVoucher = (categoryId: number, voucherId: number, params: RequestParams = {}) =>
    this.http.request<AdminVoucherDto, any>({
      path: `/v1/admin/voucher-categories/${categoryId}/vouchers/${voucherId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminVoucherService
   * @name UpdateVoucher
   * @summary Update Voucher
   * @request PUT:/v1/admin/voucher-categories/{categoryId}/vouchers/{voucherId}
   * @secure
   */
  updateVoucher = (
    categoryId: number,
    voucherId: number,
    data: AdminVoucherRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<AdminVoucherDto, any>({
      path: `/v1/admin/voucher-categories/${categoryId}/vouchers/${voucherId}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminVoucherService
   * @name DeleteVoucher
   * @summary Delete Voucher
   * @request DELETE:/v1/admin/voucher-categories/{categoryId}/vouchers/{voucherId}
   * @secure
   */
  deleteVoucher = (categoryId: number, voucherId: number, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/admin/voucher-categories/${categoryId}/vouchers/${voucherId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminVoucherService
   * @name GetVoucherCategories
   * @summary Get Voucher Categories
   * @request GET:/v1/admin/voucher-categories
   * @secure
   */
  getVoucherCategories = (
    query?: {
      searchKeyword?: string;
      /**
       * Zero-based page index (0..N)
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * The size of the page to be returned
       * @min 1
       * @default 20
       */
      size?: number;
      /** Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AdminVoucherCategoryDto[], any>({
      path: `/v1/admin/voucher-categories`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminVoucherService
   * @name CreateVoucherCategory
   * @summary Create Voucher Category
   * @request POST:/v1/admin/voucher-categories
   * @secure
   */
  createVoucherCategory = (data: AdminVoucherCategoryRequestDto, params: RequestParams = {}) =>
    this.http.request<AdminVoucherCategoryDto, any>({
      path: `/v1/admin/voucher-categories`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminVoucherService
   * @name GetVouchers
   * @summary Get Vouchers
   * @request GET:/v1/admin/voucher-categories/{categoryId}/vouchers
   * @secure
   */
  getVouchers = (
    categoryId: number,
    query?: {
      status?: 'OPEN' | 'USED' | 'EXPIRED';
      searchKeyword?: string;
      /**
       * Zero-based page index (0..N)
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * The size of the page to be returned
       * @min 1
       * @default 20
       */
      size?: number;
      /** Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AdminVoucherDto[], any>({
      path: `/v1/admin/voucher-categories/${categoryId}/vouchers`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminVoucherService
   * @name CreateVoucher
   * @summary Create Voucher
   * @request POST:/v1/admin/voucher-categories/{categoryId}/vouchers
   * @secure
   */
  createVoucher = (categoryId: number, data: AdminVoucherRequestDto, params: RequestParams = {}) =>
    this.http.request<AdminVoucherDto, any>({
      path: `/v1/admin/voucher-categories/${categoryId}/vouchers`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
